import { Injectable } from '@angular/core';

type DialogCloseCallback = () => void;

@Injectable({
  providedIn: 'root',
})
export class DialogOverlayRegistry {
  readonly #closeCallbacks = new Set<DialogCloseCallback>();

  register(close: DialogCloseCallback): () => void {
    this.#closeCallbacks.add(close);

    return () => {
      this.#closeCallbacks.delete(close);
    };
  }

  closeAll(): void {
    for (const close of [...this.#closeCallbacks]) {
      close();
    }
  }
}
